import { CheckListPalette } from '../../../components/CollectionFilters/FiltersMobile';
import { getPalettes } from '../queries';
import SelectPalette from '../../../components/SelectPalette';
export var param = 'paletteFilter';

var palette = function palette(_ref) {
  var label = _ref.label,
      values = _ref.values,
      paletteId = _ref.paletteId;
  var options = values.map(function (pal) {
    return {
      value: pal
    };
  });
  var selected = paletteId ? {
    value: paletteId
  } : false;
  return {
    expand: true,
    query: getPalettes,
    variables: {
      ids: values
    },
    component: SelectPalette,
    componentMobile: CheckListPalette,
    filter: function filter(product, value) {
      return product.colorways.edges[0].node.paletteIds.includes(value);
    },
    label: label,
    param: param,
    options: options,
    selected: selected,
    swatches: true
  };
};

export default palette;